import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=87c45aee&scoped=true"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=87c45aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c45aee",
  null
  
)

export default component.exports